// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__CF5O8","btnPrev":"Carousel_btnPrev__GINXJ","btnNext":"Carousel_btnNext__ENHxR","img":"Carousel_img__9khlc"};